const RateCardValueColumns = () => {
  return [
    {
      title: 'Department',
      dataIndex: 'department',
      align: 'center',
      render: (text, record, index) => {
        if (index === 0) {
          return {
            children: text,
            props: {
              rowSpan: 7,
            },
          };
        }
        if ([7, 15].includes(index)) {
          return {
            children: text,
            props: {
              rowSpan: 8,
            },
          };
        }
        return {
          children: text,
          props: {
            rowSpan: 0,
          },
        };
      }
    },
    {
      title: 'Position',
      dataIndex: 'position',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      editable: true,
      align: 'right',
      render: (text, record) => text && text.toLocaleString('us'),
    },
  ];
};

export default RateCardValueColumns;
